import type { TeamDailyMember } from "@msc/shared";

/**
 * Was das Board über „hat heute gebucht" **wirklich** weiß.
 *
 * Am Schema steht dazu nur ein `boolean`, und der trägt zwei verschiedene
 * Aussagen: `false` heißt entweder „hat nicht gebucht" oder „konnten wir nicht
 * feststellen" (`bookedToday` ist nur `accountId !== null && gebucht`). Die
 * Oberfläche zeigte deshalb einen Punkt bei `true` und **nichts** bei `false` —
 * und damit sah „hat nichts gebucht" genauso aus wie „diese Person hat kein
 * auflösbares Jira-Konto". Genau die Frage, die ein Daily stellt, war die
 * einzige, die man nicht beantworten konnte.
 *
 * Die fehlende Angabe steckt nicht im Mitglied, sondern daneben: `jiraLive` am
 * Board und `jiraAccountId` am Mitglied. Deshalb rechnet das hier, nicht der
 * Server: Am Schema müsste sonst ein zweites Feld entstehen, das dieselbe
 * Information ein zweites Mal trägt.
 */
export type Buchungsstand = "gebucht" | "offen" | "unbekannt";

export function buchungsstand(
  member: Pick<TeamDailyMember, "bookedToday" | "jiraAccountId">,
  jiraLive: boolean,
): Buchungsstand {
  // Ohne Jira ist jede Aussage über Buchungen geraten — auch die negative.
  if (!jiraLive) return "unbekannt";
  // Kein auflösbares Jira-Konto: Die Person mag gebucht haben, wir sehen es
  // nicht. Das als „nicht gebucht" zu zeigen wäre eine Behauptung über einen
  // Menschen, für die es keine Grundlage gibt.
  if (!member.jiraAccountId) return "unbekannt";
  return member.bookedToday ? "gebucht" : "offen";
}
